import { createSelector } from '@ngrx/store';

import { surveyFeature } from '../survey.feature';

const { selectSupplier } = surveyFeature;

export const selectSupplierAllocations = createSelector(
  selectSupplier,
  ({ allocations }) => allocations,
);

export const selectSupplierAllocationsLoading = createSelector(
  selectSupplier,
  ({ allocationsLoading }) => allocationsLoading,
);

export const selectSupplierAllocationsError = createSelector(
  selectSupplier,
  ({ allocationsError }) => allocationsError,
);

export const selectSupplierAllocationsUpdateStatus = createSelector(
  selectSupplier,
  ({ allocationsUpdateStatus }) => allocationsUpdateStatus,
);

export const selectSupplierAllocationsUpdating = createSelector(
  selectSupplierAllocationsUpdateStatus,
  (status) => status === 'saving',
);

export const selectSupplierBlends = createSelector(
  selectSupplier,
  ({ blends }) => blends,
);

export const selectSupplierBlendsLoading = createSelector(
  selectSupplier,
  ({ blendsLoading }) => blendsLoading,
);

export const selectSupplierBlendsError = createSelector(
  selectSupplier,
  ({ blendsError }) => blendsError,
);

export const selectSupplierGroupTemplates = createSelector(
  selectSupplier,
  ({ groupTemplates }) => groupTemplates,
);

export const selectSupplierGroupTemplatesLoading = createSelector(
  selectSupplier,
  ({ groupTemplatesLoading }) => groupTemplatesLoading,
);

export const selectSupplierGroupTemplatesLoadError = createSelector(
  selectSupplier,
  ({ groupTemplatesLoadError }) => groupTemplatesLoadError,
);

export const selectSupplierFlexibilityPriceParams = createSelector(
  selectSupplier,
  ({ flexibilityPriceParams }) => flexibilityPriceParams,
);

export const selectSupplierFlexibilityPriceParamsLoading = createSelector(
  selectSupplier,
  ({ flexibilityPriceParamsLoading }) => flexibilityPriceParamsLoading,
);

export const selectSupplierFlexibilityPriceParamsError = createSelector(
  selectSupplier,
  ({ flexibilityPriceParamsError }) => flexibilityPriceParamsError,
);

export const selectSupplierGroupTemplateSaving = createSelector(
  selectSupplier,
  ({ groupTemplateSaving }) => groupTemplateSaving,
);

export const selectSupplierGroupTemplateSaveError = createSelector(
  selectSupplier,
  ({ groupTemplateSaveError }) => groupTemplateSaveError,
);

export const selectSupplierBlendSaving = createSelector(
  selectSupplier,
  ({ blendSaving }) => blendSaving,
);

export const selectSupplierSavedBlendId = createSelector(
  selectSupplier,
  ({ savedBlendId }) => savedBlendId,
);

export const selectSupplierRateCards = createSelector(
  selectSupplier,
  ({ rateCards }) => rateCards,
);

export const selectSupplierRateCardsLoading = createSelector(
  selectSupplier,
  ({ rateCardsLoading }) => rateCardsLoading,
);

export const selectSupplierRateCardsError = createSelector(
  selectSupplier,
  ({ rateCardsError }) => rateCardsError,
);
